import Home2 from './home-2.vue'
export default Home2